<template>
  <div class="box-list-ebid">
    <Navbar />
    <div class="list-ebid">
      <h1>รายงานการใช้ทราย</h1>
      <b-container class="text-left">
        <b-row>
          <b-col class="search" lg="2" md="3">
            <img
              src="../../public/sss.png"
              class="img-rounded"
              alt="Cinque Terre"
              width="200"
              height="200"
            />
            <b-row class="head-search">
              <b-col lg="12">
                <h4>ค้นหาประจำวันที่</h4>
              </b-col>
            </b-row>
            <b-row class="content-search">
              <b-col lg="12" class="text-left">
                วันที่:
                <b-form-datepicker v-model="start" size="sm" class="mb-2"></b-form-datepicker>
              </b-col>
              <b-col lg="12" class="text-left">
                ถึง:
                <b-form-datepicker v-model="stop" size="sm" class="mb-2"></b-form-datepicker>
              </b-col>
              <b-col lg="12" class="space">
                <b-button class="btnsearch" style="width:100%" size="sm" @click="search">
                  <font-awesome-icon icon="search" />
                </b-button>
              </b-col>
              <b-col lg="12" class="text-left">
                จำนวนผลรวมกิโล:
                <div class="input-group mb-3">
                  <b-form-input list="list-company" size="sm" v-model="sumamount"></b-form-input>
                  <datalist id="list-company">
                    <option></option>
                  </datalist>
                  <div class="input-group-append">
                    <span class="input-group-text"></span>
                  </div>
                </div>
              </b-col>
              <b-col lg="12" class="text-left">
                จำนวนผลรวมคิว:
                <div class="input-group mb-3">
                  <b-form-input size="sm" v-model="q"></b-form-input>
                  <div class="input-group-append">
                    <span class="input-group-text"></span>
                  </div>
                </div>
              </b-col>
              
            </b-row>
          </b-col>
          <b-col lg="10" md="9" class="table">
            <vue-good-table
              :search-options="{ enabled: true }"
              :columns="columns"
              :rows="rows"
              :pagination-options="{
                enabled: true,
                perPage: 50,
                position: 'bottom',
                perPageDropdown: [10, 25, 50],
                dropdownAllowAll: false,
                setCurrentPage: 2,
                nextLabel: 'ถัดไป',
                prevLabel: 'ก่อนหน้า',
                rowsPerPageLabel: 'จำนวนข้อมูลต่อหน้า',
                ofLabel: 'จาก',
                }"
            ></vue-good-table>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "./Footer";
import axios from "axios";

export default {
  components: { Navbar, Footer },
  name: "my-component",
  data() {
    return {
      start: null,
      stop: null,
      q: null,
      sumamount: null,
      columns: [
        {
          label: "วันที่ทำรายการ",
          field: "docdate",
          width: "200px"
        },
        {
          label: "รหัสรายการ",
          field: "docno",
          width: "200px"
        },
        {
          label: "ชื่อรายการ",
          field: "description",
          width: "200px"
        },
        {
          label: "จำนวนกิโล",
          field: "amount",
          width: "200px",
          formatFn: this.formatFn
        }
      ],
      rows: []
    };
  },
  methods: {
    formatFn: function(value) {
      value = value.toLocaleString(undefined, { maximumFractionDigits: 2 });
      return value;
    },
    search: function() {
      axios
        .post("http://165.22.250.134:8081/api/suppier/sandreport/where", {
          start: this.start,
          stop: this.stop
        }) //----------------------ต่อ
        .then(response => {
          this.rows = response.data.response;
        });
      axios
        .post("http://165.22.250.134:8081/api/suppier/sandreportsum/where", {
          start: this.start,
          stop: this.stop
        }) //----------------------ต่อ
        .then(response => {
          this.sumamount = response.data.response[0].sumamount
          this.q = response.data.response[0].q
        });
    }
  },
  // mounted() {
  //   axios.get("http://165.22.250.134:8081/api/suppier/sandreport").then(response => {
  //     this.rows = response.data.response;
  //   });
  //   axios
  //     .get("http://165.22.250.134:8081/api/suppier/sandreportsum")
  //     .then(response => {
  //       this.q = response.data.response[0].q;
  //       this.sumamount = response.data.response[0].sumamount
  //         .toString()
  //         .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //     });
  // }
};
</script>

<style>
.box-list-ebid {
  min-height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgb(231, 231, 231) !important;
}
.list-ebid {
  font-family: "K2D";
  margin: 2% !important;
  padding-bottom: 10%;
}
@media (max-width: 600px) {
  .list-ebid {
    padding-bottom: 80% !important;
  }
}
@media (max-width: 1024px) {
  .list-ebid {
    margin-bottom: 20% !important;
  }
}
.box-list-ebid .list-ebid .container {
  margin-left: 0px !important;
  margin-right: 0px !important;
  max-width: 100% !important;
}
.search {
  padding: 1%;
  text-align: center;
}
.table {
  padding: 1%;
}
.head-search {
  background-color: #ff0000;
  color: white;
  padding-top: 2%;
}
.content-search {
  background-color: white;
  color: black;
  padding-top: 3%;
  padding-bottom: 5%;
}
.input-group-text {
  padding: 0px !important;
  border: 0px !important;
  background-color: #fff !important;
}
.btnsearch {
  margin-left: 3px !important;
  background-color: #ff0000 !important;
}
.btnsearch:hover {
  margin-left: 3px !important;
  background-color: rgb(27, 27, 27) !important;
}
.btnaddebid {
  margin-left: 3px !important;
  background-color: #464646 !important;
}
.btnaddebid:hover {
  margin-left: 3px !important;
  background-color: rgb(27, 27, 27) !important;
}
.center {
  padding-top: 2%;
  padding-bottom: 3%;
  text-align: center !important;
}
.space {
  margin-bottom: 6%;
}
.label {
  color: red;
}
.modal-header {
  background-color: #000203 !important;
  color: white !important;
}
</style>
